import { render, staticRenderFns } from "./AppealReview.vue?vue&type=template&id=67af49e4&scoped=true"
import script from "./AppealReview.vue?vue&type=script&lang=js"
export * from "./AppealReview.vue?vue&type=script&lang=js"
import style0 from "./AppealReview.vue?vue&type=style&index=0&id=67af49e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67af49e4",
  null
  
)

export default component.exports